module.exports = __webpack_public_path__ + "static/rawpixel-557123-unsplash-c39c8c1d5e309a024a6148e9e6d43cfd.jpg";